module.exports = __webpack_public_path__ + "static/media/bar3.45763ea3.jpg";